import React, {ReactNode, useMemo} from 'react';

import {useGate, useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {fetchGridConfig, saveGridConfig} from 'api/gridsConfig';
import {mapTableColumns, Table} from 'components/ui-kit/Table2.0';
import {permissions$} from 'models/auth';
import {customsUsersState$, Gate, pageNumberChanged} from 'models/customs/users/table';
import {UserPermission} from 'types';

import {CustomsUserRow} from 'types/profile';

interface Props {
    configFunc: (t: TFunction, permissions?: UserPermission[]) => Array<any>;
    dataMapper: (data?: CustomsUserRow[] | undefined) => Array<any>;
    headerControls?: ReactNode;
    exportConfig?: {
        exportPending: boolean;
        callback: Function;
    };
}

export const CustomsUsersGridTable = ({
    configFunc,
    dataMapper,
    headerControls,
    exportConfig,
}: Props) => {
    const {t} = useTranslation();
    const state = useStore(customsUsersState$);
    const permissions = useStore(permissions$);
    const params = useParams<{id: string}>();
    useGate(Gate, {id: params.id});

    const columns = useMemo(() => mapTableColumns(configFunc(t, permissions)), [t]);
    const mappedData = React.useMemo(() => dataMapper(state.data?.data), [dataMapper, state, t]);

    return (
        <Table
            columns={columns}
            data={mappedData}
            totalRowsCount={state.data?.totalElements}
            pageCount={state.data?.totalPages}
            pageIndex={state.data?.page}
            onPageChange={pageNumberChanged}
            isLoading={state.isLoading}
            headerControls={headerControls}
            userConfig={{
                gridName: 'staffGrid',
                saveConfig: saveGridConfig,
                getConfig: fetchGridConfig,
            }}
            exportConfig={exportConfig}
        />
    );
};
